var $ = jQuery; 
 
$(document).ready(function(){

	accordion();
	
});

$(document).on('click', 'a[href^="#"]', function (event) {
	event.preventDefault();

	$('html, body').animate({
		scrollTop: $($.attr(this, 'href')).offset().top - 100
	}, 500);
});

/* FANCYBOX */
document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.Fancybox === 'undefined') {
        return;
    }

    Fancybox.bind('[data-fancybox]');
});

/* LAZY LOAD VIDEO */
document.addEventListener("click", function(e) {
  if (e.target.closest(".lazy-video")) {
    const wrapper = e.target.closest(".lazy-video");
    const src = wrapper.dataset.src + "?autoplay=1&rel=0&showinfo=0";
    wrapper.innerHTML = `<iframe src="${src}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen loading="lazy"></iframe>`;
  }
});

/********************************************************************************
	# Open and Close Accordions
********************************************************************************/
function accordion() {
	if ($('.accordion').length) {
		
		$('body').on('click','.accordion-row__question', function(){
			var el = $(this);
			var el_parent = el.parent();
			var el_answer = el.next();
			var el_siblings = el_parent.siblings();
			
			if (el_parent.attr('data-status') !== 'is-open') {

				el_parent.attr('data-status', 'is-open');
				el_answer.slideDown();
				
			} else {
				
				el_parent.attr('data-status', 'is-closed');
				el_answer.slideUp();

				
			}
			
		});
		
	}		
}

/* function mmenuInit() {

	var $menu = jQuery("#my-menu").mmenu({
		"extensions": [
			"fx-menu-zoom",
			"position-right",
			"pagedim-black"

		],
		"pageScroll": true,
		"navbar": {
			"title": "<a href='/'><img class='img-fluid' src='/wp-content/themes/wtm-digital/assets/img/logos/logo.svg'></a>"
		},
		},
		{
			// configuration
			offCanvas: {
				pageSelector: ".site"
			},
			clone: true
	});

	var $icon = jQuery(".hamburger");

	var API = $menu.data( "mmenu" );

	$icon.on( "click", function() {
		API.open();
	});

	API.bind( "open:finish", function() {
		setTimeout(function() {
			jQuery(".hamburger").addClass( "is-active" );
		}, 100);
	});
	API.bind( "close:finish", function() {
		setTimeout(function() {
			jQuery(".hamburger").removeClass( "is-active" );
		}, 100);
	});
} */


/* function FAQs() {
	$('body').on('click', '.faq__question', function() {
		var el = $(this);
		if (el.parent().attr('data-status') == 'is-active') {
			el.parent().attr('data-status', '');
			el.next('.faq__answer').slideUp();
		} else {
			el.parent().attr('data-status', 'is-active');
			el.next('.faq__answer').slideDown();
		}
	});
} */

/* function moveUtilityMenu (win) {
	var utilNav = $('.menu-top-menu-container');
		if (win.width() <= 1280) {
			$( ".hamburger" ).click(function() {
				utilNav.appendTo($('.mm-panel.mm-panel_has-navbar.mm-panel_opened'));
			});
		}else {
			if(utilNav.closest($('.mm-panels')).length > 0) {
				utilNav.prependTo($('.main-nav__top'));
			}
		}
}
	
$(window).on('resize', function(){
	moveUtilityMenu($(this));
}); */